import React, { useEffect,useRef,useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import {
	Row,
	Col,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  ModalFooter,
  Modal,
  FormText
} from 'reactstrap'
import Select from "react-select";
import Category from 'lib/Core/Backend/Controllers/Category';
import Catalogs from 'lib/Core/Backend/Controllers/Catalogs';
import Brand from 'lib/Core/Backend/Controllers/Brand'
import Notify from 'lib/Utils/Alert';
import NotificationAlert from "react-notification-alert";
import Spinner from 'react-bootstrap/Spinner';
const EditBrandModal = ({
  isOpen,
  toggle,
  onOpened,
  activeOp,
  activeOpText,
  onLogoChange,
  handleCancelClick,
  handleSaveClick,
  brandsLoading,
  formRef,
  categoryOption,
  setCategoryOption,
  category,
  setCategory,
  name,
  setName,
  description,
  setDescription,
  currencyOption,
  setCurrencyOption,
  currency,
  setCurrency,
  redem,
  setRedem,
  termscondition,
  setTermsCondition,
  region,
  setRegion,
  regionOption,
  setRegionOption,
  stock,
  setStock,
  image,
  setImage,
  defaultCategory,
  setDefaultCategory,
  defaultRegion,
  setDefaultRegion,
  defaultCurrency,
  edit,
  setDefaultCurrency,
  lastUpdated,
  setLastUpdated,
  regionField,
  setRegionField,
  token,
  activate,
  setActivate
}) => {
  const categoriesCtl = new Category(token);
  const catalogsCtl = new Catalogs(token);
  const brandsCtl = useMemo(() => new Brand(token),[token]);
  const logoControl = useRef()
 const [buttonDisable,setButtonDisable] = useState(false)
 const alert = useRef();
  useEffect(()=>{
    categoriesCtl.all(data => {
			if(!(data.error || data.errorMessage)){
        const categorydata = data.map(item=>({
          value: item.id,
          label: item.name

        }))
				setCategoryOption(categorydata)
			}
		})

    catalogsCtl.currencies(data => {
			if(!(data.error || data.errorMessage)){
        
        const currecyData = data.map(item=>({
          value: item.id,
          label: item.name
        }))
        
				setCurrencyOption(currecyData)
			}
		})

   
  },[])

  const handlecategory = (selectedOption) =>{
    const options = selectedOption?.value;
    setCategory(options)
    setDefaultCategory(selectedOption)

  }

  const handleCurrency = (options) =>{
    const currencyoptions = options?.value
    setCurrency(currencyoptions);
    setDefaultCurrency(options)
    if(options !== null){
      if(currencyoptions){
        catalogsCtl.regionByCurrency(currencyoptions,(data)=>{
          if(!(data.error || data.errorMessage)){
            const regiondata = data.map(item=>({
              value: item.id,
              label: item.name
            }))
            
          //   setRegionOption(regiondata.concat({
          //     value: 0,
          //     label: "Add New Region"
          // }));
          setRegionOption(regiondata)
          }
        })
       }
    }else{
      setRegionOption([])
    }
 
  }

  const handleRegion = (options) =>{
    const regionoption = options?.label
     setRegion(regionoption);
    setDefaultRegion(options)
    if(regionoption !== ""){
      setRegionField(false)
    }
    if(options !== null){
      setButtonDisable(true)
    }else{
      setButtonDisable(false)
    }

  }
  const handleNewRegion = () =>{
    setRegionField(true)
  }
  const handlelogo = (event) =>{ 
    if (event?.target?.files[0]){
      if(event?.target?.files[0].size > 5242880){
        Notify(alert, 'danger', 'File size exceeds 5mB')
				event.target.value = null
				logoControl.current.style.backgroundImage = `none`;
				return
			}
			logoControl.current.style.backgroundImage = `url('${URL.createObjectURL(event?.target?.files[0])}')`;
       setImage(event?.target?.files[0])
		} else
			logoControl.current.style.backgroundImage = `none`;
  }

  const handleActivation = (e) =>{
    const value  = e.target.checked
  setActivate(value)
  }


  return(
    <>
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" onOpened={onOpened} size="lg">
      <NotificationAlert ref={alert}/>
        <ModalHeader toggle={handleCancelClick}>{activeOp} Brand</ModalHeader>
        <ModalBody>
         <div className='d-lg-flex justify-content-between'>
            <div>
              <p className="card-just-text">
                {activeOpText}
              </p>
            </div>
            
              <div className="form-check form-switch mb-0">
                <p className="d-inline-block" style={{paddingRight:"43px", fontSize:"17px"}}>Inactive</p>
              <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={activate} onChange={(e) => handleActivation(e)} style={{ cursor: "pointer" }} />
              <p className="form-check-label" htmlFor="flexSwitchCheckDefault">Active</p>
              </div>
          </div>
          <Form innerRef={formRef} encType="multipart/form-data">
            <Input type="hidden" name="brandId"/>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <label for="category">Category <span style={{color:"red"}}>*</span></label>
                  <Select 
                  value={defaultCategory}
                  options={categoryOption}
                  isMulti={false}
                  onChange={handlecategory}
                  isClearable={true} 
                  id="category"/>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="name">Name <span style={{color:"red"}}>*</span></Label>
                  <Input id="name" name="name" type="text" placeholder="Name of the new brand" value={name} onChange={(e)=>setName(e.target.value)}/>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <label for="currency">Currency <span style={{color:"red"}}>*</span></label>
                  <Select 
                  value={defaultCurrency}
                  options={currencyOption}
                  isMulti={false}
                  onChange={handleCurrency}
                  isClearable={true} 
                  isDisabled={edit}
                   id="currency"/>
                </FormGroup>
              </Col>
            </Row>
           
            <Row form>
              <Col md={12}>
                {/* {regionField === true ?  */}
                
                <FormGroup>
                  <label for="region">Region <span style={{color:"red"}}>*</span></label>
                  <Select 
                  value={defaultRegion}
                  options={regionOption}
                  isMulti={false}
                  onChange={handleRegion}
                  isClearable={true} 
                  isDisabled={edit}
                  id="region"/>
                </FormGroup>
                { regionField === true && edit === false ? 
                <FormGroup>
                   <label for="region">New Region <span style={{color:"red"}}>*</span></label>
                   <Input id="region" name="region" type="text"placeholder="Add Region" value={region} onChange={(e)=>setRegion(e.target.value)}/>
                </FormGroup>
              :"" }
              </Col>
            </Row>
            <Row>
              {edit === false ?
              
              <Col md={12} className='d-flex justify-content-end align-items-center' style={{height:"36px"}}>
                <FormGroup style={{marginTop:"20px"}}>
                  <Button className='btn btn-primaryTwo' onClick={()=>handleNewRegion()} disabled={buttonDisable} style={{height:"38px", width:"150px" }}><span style={{fontSize:"10px"}}>Create New Region</span></Button>
                </FormGroup>
              </Col>
              : ""}
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="description">Description</Label>
                  <Input id="description" name="description" type="textarea" style={{minHeight:"70px"}} placeholder="Brand description" value={description} onChange={(e)=>setDescription(e.target.value)} maxLength="2000"/>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="redeemInstruct">Redemption Instructions</Label>
                  <Input id="redeemInstruct" name="redeemInstruct" type="textarea" style={{minHeight:"70px"}} placeholder="Instructions to redeem the gift card" value={redem} onChange={(e)=>setRedem(e.target.value)} maxLength="2000"/>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="terms">Terms And Conditions</Label>
                  <Input id="terms" name="terms" type="textarea" style={{minHeight:"70px"}} placeholder="Terms and conditions for the usage of the gift cards" value={termscondition}  onChange={(e)=>setTermsCondition(e.target.value)}/>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="lowInvThres">Low Stock Threshold <span style={{color:"red"}}>*</span></Label>
                  <Input id="lowInvThres" name="lowInvThres" type="number" placeholder="Minimum units in stock" value={stock} onChange={(e)=>setStock(e.target.value)} />
                </FormGroup>
              </Col>
            </Row>
            <div style={{margin: "10px", textAlign: "right", fontWeight: "bold"}} id="lastEdited">Last updated on: {lastUpdated}</div>
            <Row form>
              <Col md={2} className="justify-content-center">
                <div ref={logoControl} className="ncentiva-brand-logo-block" style={edit ? {backgroundImage: `url('${brandsCtl.logo(image)}')`} : {}}/>
              </Col>
              <Col md={10} style={{paddingLeft: "15px"}}>
                <FormGroup>
                  <Label for="logoFile">Image file for the logo <span style={{color:"red"}}>*</span></Label>
                  <Input type="file" name="logoFile" id="logoFile" onChange={handlelogo} accept="image/jpeg, image/png"/>
                  <FormText color="muted">
                    The image must be in PNG or JPEG format, and be 500x500 pixels in size.
                  </FormText>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCancelClick}>Cancel</Button>{' '}
          <Button className='btn btn-primaryTwo' onClick={handleSaveClick} disabled={brandsLoading}>{!brandsLoading && "Save"} {
            brandsLoading && <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{
              margin: "0px 8px"
            }}
          />}</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}


EditBrandModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onOpened: PropTypes.func.isRequired,
  activeOp: PropTypes.string.isRequired,
  activeOpText: PropTypes.string.isRequired,
  logoControl: PropTypes.any.isRequired,
  onLogoChange: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
  handleSaveClick: PropTypes.func.isRequired,
  formRef: PropTypes.any.isRequired
}

export default EditBrandModal